import appConfig from 'helper/mapBackendConfig';

export const getSchemeBaseURL = (eid: string = appConfig.env.id): string => {
	switch (eid) {
		case 'PROD':
			return 'ch.migros.impuls';
		case 'TEST':
		case 'TEST-PROD':
			return 'ch.migros.impuls.quality';
		case 'DEV':
		case 'DEV-PROD':
			return 'ch.migros.impuls.development';
		default:
			break;
	}

	return 'ch.migros.impuls';
};

export const Schemes = {
	LOAD: 'webapp/load',
};
